'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _taggedTemplateLiteral = require('@babel/runtime/helpers/taggedTemplateLiteral');
var react = require('@emotion/react');
var styled = require('@emotion/styled');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _taggedTemplateLiteral__default = /*#__PURE__*/_interopDefaultLegacy(_taggedTemplateLiteral);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var _templateObject, _templateObject2, _templateObject3;
var ThumbnailListViewStyles = function ThumbnailListViewStyles(theme) {
  var thumbnailRadius = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return (
    /*#__PURE__*/
    /*#__PURE__*/
    react.css("height:100%;padding-top:0;", thumbnailRadius && "\n    border-top-left-radius: ".concat(theme.radii.medium, ";\n    border-bottom-left-radius: ").concat(theme.radii.medium, ";\n    "), ";" + ("production" === "production" ? "" : ";label:ThumbnailListViewStyles;"), "production" === "production" ? "" : ";label:ThumbnailListViewStyles;")
  );
};
var ThumbnailGalleryViewStyles = function ThumbnailGalleryViewStyles(theme) {
  var thumbnailRadius = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return (
    /*#__PURE__*/
    /*#__PURE__*/
    react.css("height:100%;width:100%;", thumbnailRadius && "\n    border-top-left-radius: ".concat(theme.radii.medium, ";\n    border-top-right-radius: ").concat(theme.radii.medium, ";\n    "), ";" + ("production" === "production" ? "" : ";label:ThumbnailGalleryViewStyles;"), "production" === "production" ? "" : ";label:ThumbnailGalleryViewStyles;")
  );
};
var SThumbnail = styled__default["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral__default["default"](["\n    background-color: #eceeef;\n    box-sizing: border-box;\n    overflow: hidden;\n    position: relative;\n\n    ", "\n\n    ", "\n"])), function (props) {
  return props.type !== 'list' && "\n        &:before {\n            display: block;\n            content: \"\";\n            width: 100%;\n            padding-top: ".concat(props.vertical ? '125%' : '75%', ";\n        }\n    ");
}, function (props) {
  return props.type === 'list' ? ThumbnailListViewStyles(props.theme, props.thumbnailRadius) : ThumbnailGalleryViewStyles(props.theme, props.thumbnailRadius);
});
var SThumbnailInner = styled__default["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral__default["default"](["\n    align-items: center;\n    bottom: 0;\n    display: flex;\n    justify-content: center;\n    left: 0;\n    position: absolute;\n    right: 0;\n    top: 0;\n"])));
var SImage = styled__default["default"].img(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral__default["default"](["\n    object-fit: cover;\n\n    ", "\n\n    ", "\n"])), function (_ref) {
  var transitionDuration = _ref.transitionDuration,
    isHidden = _ref.isHidden;
  return "\n        transition: opacity ".concat(transitionDuration, "ms ease-in-out;\n        opacity: ").concat(isHidden ? '0' : '1', ";\n    ");
}, function (props) {
  return props.fitThumbnail ? "\n                width: 50%;\n                height: auto;\n            " : "\n                width: 100%;\n                height: 100%;\n            ";
});

exports.SImage = SImage;
exports.SThumbnail = SThumbnail;
exports.SThumbnailInner = SThumbnailInner;
//# sourceMappingURL=Thumbnail.style.js.map
